import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import i18n from '@/lang/lang';
import { darkMode } from '@/store/function/common/darkMode';
import { delay } from '@/utils/tool';
import { logoutApi } from '@/api';
import { projectSolarRoutes, projectEnergyRoutes } from '@/router/routes';

import { mapState, mapMutations, mapActions } from 'vuex';
function setLinkContent(route) {
  return {
    name: route.name,
    icon: route.meta.icon,
    zhTw: route.meta.zhTw
  };
}
var hideNavbarAndSidebarPages = ['login', 'tvscreen', 'tvwalllooping', 'SituationRoom'];
export default {
  name: 'App',
  data: function data() {
    return {
      hasNavbarAndSidebar: false,
      projectName: '',
      menuLinkList: [],
      isChangingProject: false,
      langSelected: 'tw',
      isSideMenuExpanded: false,
      langSelection: false,
      factorySelection: false,
      changeMode: false,
      isFocusing: false,
      timer: undefined,
      isLoggedIn: false,
      // 判斷是否已登入 -> keep-alive
      ws: undefined // websocket
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['userDetail', 'solarPermissionArray', 'energyPermissionArray', 'roomPermissionArray', 'projects', 'roleComponentMenu', 'hasRoleAdmin'])), {}, {
    lang: function lang() {
      return this.langSelected || 'tw';
    },
    logoLink: function logoLink() {
      var _this$menuLinkList$;
      // 給預設值 fix warning: relative params navigation requires a current route
      return {
        name: ((_this$menuLinkList$ = this.menuLinkList[0]) === null || _this$menuLinkList$ === void 0 ? void 0 : _this$menuLinkList$.name) || 'realtime',
        params: {
          lang: this.lang
        }
      };
    },
    routeName: function routeName() {
      return this.$route.name;
    }
  }),
  watch: {
    // if the route changes...
    // 之後改用 router beforeEach(?)
    $route: function $route(to, from) {
      // 非已登入狀態 頁面不緩存
      var token = localStorage.getItem('userDetail') || '';
      this.isLoggedIn = !!token;

      // 若點上/下一頁 route 不同，更新 projectName, menuLinkList
      var fromProjectPathName = from.path.split('/')[2];
      var toProjectPathName = to.path.split('/')[2];
      if (fromProjectPathName !== toProjectPathName) {
        this.setProjectNameAndMenuLinkList();
      }
      this.hasNavbarAndSidebar = !hideNavbarAndSidebarPages.includes(this.routeName);
    },
    '$route.params.lang': {
      immediate: true,
      handler: function handler(newLang) {
        if (newLang && this.langSelected !== newLang) {
          this.langSelected = newLang;
          i18n.locale = newLang;
        }
      }
    },
    isLoggedIn: function isLoggedIn(_newVal, _preVal) {
      if (this.isLoggedIn) {
        this.startWebsocket();

        // 更新登入的使用者可看的內容權限 (permissionArray) (不判斷是否同一人)
        this.UPDATE_ROLE_ARRAY(); // 更新權限
        this.setProjectNameAndMenuLinkList();
      } else {
        this.ws.close();
      }
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMutations(['CHANGE_DARK_MODE', 'CHANGE_LIGHT_MODE', 'CHANGE_REALTIME_RELOAD', 'UPDATE_ROLE_ARRAY'])), mapActions(['setTelemetryData', 'setDidoStatus'])), mapActions('projectEnergy', ['setEnergyMinData'])), {}, {
    chooseLanguage: function chooseLanguage(select) {
      this.langSelected = select;
      i18n.locale = select;
      this.$router.push({
        name: this.$route.name,
        params: _objectSpread(_objectSpread({}, this.$route.params), {}, {
          lang: select
        }),
        query: this.$route.query
      }).catch(function (err) {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation')) {
          console.error(err);
        }
      });
    },
    isRealtimeSiteInfoActive: function isRealtimeSiteInfoActive(sidebarActiveName) {
      // 在 render sidebar 的 items 時
      // item name 是 realtime 且 目前在 siteInfo 相關頁面
      return sidebarActiveName === 'realtime' && this.roleComponentMenu.includes(this.routeName);
    },
    setProjectNameAndMenuLinkList: function setProjectNameAndMenuLinkList() {
      this.setProjectName(); // 專案名稱
      this.setMenuLinkList(); // 依據(權限)(專案)設定 menuLinkList
    },
    setProjectName: function setProjectName() {
      var _location = location,
        hostname = _location.hostname,
        pathname = _location.pathname;
      if (hostname === 'acmepointes-dev.azurewebsites.net') {
        this.projectName = '雲端監控中心-測試機';
      } else if (pathname.includes('energy')) {
        this.projectName = '電能可視化管理';
      } else {
        this.projectName = '雲端監控中心';
      }
    },
    handleChangeProject: function handleChangeProject(buttonLabel) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$menuLinkList$2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isChangingProject = true;
                _context.next = 3;
                return delay(0.4);
              case 3:
                _this.projectName = buttonLabel;
                _this.isChangingProject = false;
                _this.setMenuLinkList();
                _this.$router.push({
                  name: (_this$menuLinkList$2 = _this.menuLinkList[0]) === null || _this$menuLinkList$2 === void 0 ? void 0 : _this$menuLinkList$2.name,
                  params: {
                    lang: _this.lang
                  }
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setMenuLinkList: function setMenuLinkList() {
      var _this2 = this;
      switch (this.projectName) {
        case '電能可視化管理':
          this.menuLinkList = projectEnergyRoutes.filter(function (route) {
            return _this2.energyPermissionArray.includes(route.name);
          }).map(setLinkContent);
          break;
        default:
          // 雲端監控中心 / 雲端監控中心-測試機
          this.menuLinkList = projectSolarRoutes // filter routes 權限 呈現的項目
          .filter(function (route) {
            var _route$meta;
            return ((_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.showMenu) && _this2.solarPermissionArray.includes(route.name);
          }).map(setLinkContent);
          break;
      }
    },
    startWebsocket: function startWebsocket() {
      var _this3 = this;
      var socketOrigin = location.hostname === 'localhost' ? 'ws://localhost:3000' : "wss://".concat(location.hostname);
      if (location.pathname !== '/tvscreen' || location.pathname !== '/tw/tvwalllooping') {
        this.ws = new WebSocket(socketOrigin);
        this.ws.onopen = function () {
          console.log('open connection');
        };
        this.ws.onclose = function () {
          console.log('close connection');
        };
        this.ws.onmessage = function (_ref) {
          var data = _ref.data;
          try {
            // if (this.isFocusing) {
            var message = JSON.parse(data);
            if (message.didofactoryName) {
              console.log(message);
              _this3.setDidoStatus(message);
            }
            // if (message.factoryName === 'bonitest' || message.factoryName === 'bonitest2') {
            //   console.log(message)
            //   console.log(message.detail.etc)
            // }
            if (message.field_name) {
              // console.log('message.field_name', message)
              _this3.setEnergyMinData(message);
            }
            // }
          } catch (error) {
            console.log(error);
          }
        };
        window.onmousemove = function (ev) {
          if (ev.isTrusted) {
            _this3.isFocusing = true;
            _this3.timer = setTimeout(function () {
              _this3.isFocusing = false;
            }, 60 * 1000);
          }
        };
      }
    },
    signOut: function signOut() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return logoutApi().then(function () {
                  localStorage.removeItem('userDetail');
                  _this4.CHANGE_REALTIME_RELOAD(true);
                  _this4.$router.push({
                    path: "/".concat(_this4.lang, "/login")
                  }).catch(function (err) {
                    return console.log('router push has error', err);
                  });
                });
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleNewPageToSituationRoom: function handleNewPageToSituationRoom() {
      var routeData = this.$router.resolve({
        name: 'SituationRoom'
      });
      window.open(routeData.href, '_blank');
    },
    mouseleave: function mouseleave() {
      if (this.langSelection) {
        this.langSelection = !this.langSelection;
      }
      if (this.factorySelection) {
        this.factorySelection = !this.factorySelection;
      }
    },
    setDarkMode: function setDarkMode() {
      darkMode();
      this.CHANGE_DARK_MODE();
      this.changeMode = !this.changeMode;
    },
    setLightMode: function setLightMode() {
      var set = document.documentElement.style;
      var styleArray = ['--acmeNavbar', '--sidebar', '--appBackground', '--normaltextcolor', '--icon', '--acmeTableTitle', '--acmecelltitle', '--acmeTabledata', '--acmePageTitle', '--acmeLogo', '--styleButton', '--linearButtonAndTitle', '--borderColor', '--siteinfoBackground', '--barItemBackground', '--siteInfoDetailBorder', '--infoCategoryBackground', '--infoCategoryBefore', '--siteinfoKeys', '--barItem', '--barItemClicked', '--chooseButton', '--titleLinear', '--borderBoxShow'];
      for (var i = 0; i < styleArray.length; i++) {
        set.removeProperty(styleArray[i]);
      }
      this.CHANGE_LIGHT_MODE();
      this.changeMode = !this.changeMode;
    }
  }),
  created: function created() {
    var _location2 = location,
      hostname = _location2.hostname,
      protocol = _location2.protocol;
    if (protocol === 'http:' && hostname === 'om.acmepointes.com') {
      location.assign('https://om.acmepointes.com');
    }
  }
};